module.exports = __webpack_public_path__ + "static/media/setpoint-grzanie.65347f1e.svg";